var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFurniture(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 16.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.8625 20.8612)",
    fill: "none",
    width: 3,
    height: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M32.2,9.9h0.2c0.1-0.2,0.4-0.2,0.6-0.1l0.7,0.3l0.8-0.7c0.2-0.2,0.5-0.3,0.7-0.1l1.3,1V8.7h-4.3V9.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.7,
    y: 22,
    fill: "none",
    width: 2.1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.5,20h-2v-1.8c0.6-0.3,1-0.8,1.1-1.5v-1.1c0-0.3-0.3-0.5-0.6-0.5h-2.1c-0.3,0-0.5,0.2-0.5,0.5v1.1 c0,0.6,0.4,1.2,1,1.5v1.7h-2c-0.1,0.2-0.1,0.3-0.1,0.5l0.5,2.5H27v-1h2.6c0.9,0,1.6-0.7,1.6-1.6v-5.2c0-0.9-0.7-1.6-1.6-1.6H20 c-0.9,0-1.6,0.7-1.6,1.6v5.3c0,0.9,0.7,1.6,1.6,1.6h2.6v1h-4.2v-0.5c0-0.6-0.5-1.1-1.1-1.1h-1.6c-0.6,0-1.1,0.5-1.1,1.1V23H14 c-0.2-1.1-1.1-1.9-2.2-2l-1.7-3.5c0.5-0.3,0.8-0.8,0.8-1.4c0-0.4-0.1-0.7-0.4-1l1-0.5c-0.1,0.1-0.1,0.3-0.1,0.5 c0,0.3,0.3,0.5,0.6,0.5h4.2c0.3,0,0.6-0.2,0.6-0.5c0-0.9-0.4-1.7-1.1-2.2v-0.5c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6v0.5 l-3.4,1.6c-0.9-0.1-1.6,0.6-1.7,1.5c-0.1,0.9,0.6,1.6,1.5,1.7l1.7,3.4c-0.9,0.2-1.6,1-1.8,1.9H8.2c-0.3,0-0.5,0.3-0.5,0.6v2.1 c0,0.3,0.2,0.5,0.5,0.5h1.1v10.7c0,0.3,0.2,0.5,0.5,0.5h2.7c0.3,0,0.5-0.2,0.5-0.5V26.2h19.2v10.7c0,0.3,0.2,0.5,0.5,0.5h2.7 c0.3,0,0.5-0.2,0.5-0.5V26.2H37c0.3,0,0.5-0.2,0.5-0.5v-2.1c0-0.3-0.2-0.5-0.5-0.5l0.5-2.6C37.6,20.3,37.5,20.2,37.5,20z  M14.2,11.9c0.3,0,0.5,0.2,0.5,0.5h-1C13.7,12.1,13.9,11.9,14.2,11.9z M14.2,13.5c0.7,0,1.3,0.4,1.5,1h-3 C12.9,13.9,13.5,13.5,14.2,13.5z M9.4,16.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5 C9.9,16.4,9.6,16.6,9.4,16.6z M34.4,16.1h1.1v0.6c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.6-0.2-0.6-0.5V16.1z M36.5,20.9L36,23h-2.1 l-0.4-2.1H36.5z M19.5,15.1c0-0.3,0.3-0.6,0.6-0.6h9.5c0.3,0,0.6,0.3,0.6,0.6v3.7H19.5V15.1z M20,20.9c-0.3,0-0.6-0.2-0.6-0.5v-0.5 h10.7v0.5c0,0.3-0.3,0.5-0.6,0.5H20z M25.9,22v1h-2.1v-1H25.9z M15.7,22.5h1.6V23h-1.6V22.5z M11.4,22c0.7,0,1.3,0.4,1.5,1h-3 C10.2,22.4,10.8,22,11.4,22z M12,36.3h-1.6V26.2H12V36.3z M35,36.3h-1.6V26.2H35V36.3z M36.5,25.2H8.9v-1.1h24.5h3.2V25.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9C9C9",
    points: "36,23 36.5,20.9 33.5,20.9 33.9,23  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B949",
    d: "M35,17.2c0.3,0,0.5-0.2,0.5-0.5v-0.6h-1.1v0.6C34.4,17,34.7,17.2,35,17.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 22.5,
    fill: "#00B949",
    width: 1.6,
    height: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M14.2,11.9c-0.3,0-0.5,0.2-0.5,0.5h1C14.7,12.1,14.4,11.9,14.2,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M14.2,13.5c-0.7,0-1.3,0.4-1.5,1h3C15.4,13.9,14.8,13.5,14.2,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M11.4,22c-0.7,0-1.3,0.4-1.5,1h3C12.7,22.4,12.1,22,11.4,22z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9F9F9",
    cx: 9.4,
    cy: 16.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4,
    y: 26.2,
    fill: "#C9C9C9",
    width: 1.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9C9C9",
    points: "8.9,24.1 8.9,25.2 36.5,25.2 36.5,24.1 33.4,24.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 26.2,
    fill: "#C9C9C9",
    width: 1.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M30.2,20.4v-0.5H19.5v0.5c0,0.3,0.3,0.5,0.6,0.5h9.5C29.8,20.9,30.1,20.7,30.2,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M30.2,15.1c0-0.3-0.3-0.6-0.6-0.6H20c-0.3,0-0.6,0.3-0.6,0.6v3.7h10.7V15.1z M22.5,18.2L22.5,18.2l-0.8-0.8 l-0.1-0.1l2.1-2.1l0.1,0.1l0.8,0.7L22.5,18.2z M25.7,18.1L25,17.3l2.1-2.1l0.8,0.8L25.7,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M26.4,28.9c0-0.9-0.7-1.6-1.6-1.6h-4.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6h0.3L19,36.7v0.7H20V37 l1.9-6.5h0.2v6.9h1v-6.9h0.2l2,6.5v0.4h1v-0.7l-1.9-6.2h0.3C25.6,30.5,26.4,29.8,26.4,28.9z M20.5,29.4c-0.3,0-0.5-0.2-0.5-0.5 s0.2-0.5,0.5-0.5h4.2c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5H20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M25.2,28.9c0-0.3-0.2-0.5-0.5-0.5h-4.2c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h4.2 C25,29.4,25.2,29.2,25.2,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00BAE0",
    d: "M37,7.6h-5.3c-0.3,0-0.6,0.2-0.6,0.5v4.3c0,0.3,0.3,0.5,0.6,0.5H37c0.3,0,0.5-0.2,0.5-0.5V8.1 C37.5,7.8,37.3,7.6,37,7.6z M36.5,10.3l-1.3-1c-0.2-0.2-0.5-0.1-0.7,0.1l-0.8,0.7L33,9.8c-0.2-0.1-0.5-0.1-0.6,0.1h-0.2V8.7h4.3 V10.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF693C",
    points: "21.7,17.4 22.5,18.1 22.5,18.2 24.7,16 23.9,15.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.9,
    y: 16.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.0409 23.5443)",
    fill: "#FF693C",
    width: 3,
    height: 1.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture);
export default __webpack_public_path__ + "static/media/furniture.63c21bdad135a8d7b2514cc7ef290a56.svg";
export { ForwardRef as ReactComponent };